import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  LineElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    title: {
      display: false,
      text: "Annualize LCC",
    },
  },
  scales: {
    x: {
      color: "#d7d7d7",
      ticks: {
        precision: 0,
        color: "#d5d5d5",
      },
      title: {
        display: true,
        color: "#d7d7d7",
        text: "Year",
      },
      stacked: true,
    },
    y: {
      color: "#d7d7d7",
      ticks: {
        precision: 0,
        color: "#d5d5d5",
      },
      title: {
        display: true,
        color: "#d7d7d7",
        text: "Amount (USD)",
      },
      stacked: true,
    },
  },
};

const labels = [
  "2015",
  "2016",
  "2017",
  "2018",
  "2019",
  "2020",
  "2021",
  "2022",
  "2023",
  "2024",
  "2025",
  "2026",
  "2027",
  "2028",
  "2029",
  "2030",
  "2031",
  "2032",
];
//generate random data for 7 years with custom min and max
const generateRandomArray = (length, min, max) => {
  return Array.from(
    { length },
    () => Math.floor(Math.random() * (max - min + 1)) + min
  );
};
const array = generateRandomArray(16, 10000, 100000);

function App({ allData }) {
  const [data, setData] = useState({
    labels,
    datasets: [
      {
        label: "Total LCC",
        data: [
          100000, 103000, 106000, 108000, 110000, 112000, 113000, 114000,
          116000, 122000, 129000, 133000, 138000, 144000, 152000, 167000,
        ],
        backgroundColor: "rgb(99,161,255)",
        borderColor: "rgb(99,161,255)",
        stack: "stack0",
      },
      {
        label: "Simulated LCC",
        data: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          100000,
          103000,
          106000,
          108000,
          110000,
          112000,
          116000,
        ],
        backgroundColor: "rgb(255,229,99)",
        borderColor: "rgb(255,229,99)",
        stack: "stack1",
      },
      {
        label: "Annualized LCC",
        data: [
          100000, 95000, 88000, 85000, 82000, 77000, 74000, 71000, 69000, 66000,
          64000, 61000, 59000, 56000, 54000, 52000, 50000,
        ],
        backgroundColor: "rgb(255, 99, 132)",
        borderColor: "rgb(255, 99, 132)",
        stack: "stack2",
      },
      {
        label: "Unit Price",
        data: [
          100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000,
          100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000,
          100000,
        ],
        backgroundColor: "rgb(99,255,120)",
        borderColor: "rgb(99,255,120)",
        stack: "stack3",
      },
      {
        label: "Simulated Annualized LCC",
        data: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          100000,
          80000,
          70000,
          65000,
          60000,
          58000,
          57000,
        ],
        backgroundColor: "rgb(75, 192, 192)",
        borderColor: "rgb(75, 192, 192)",
        stack: "stack4",
      },
    ],
  });
  useEffect(() => {
    const data_annualized = allData.map((item) => item["Annualized LCC"]);
    const total_lcc = allData.map((item) => item["Total_Cost"]);
    const cumulative = allData.map((item) => item["Cumulative LCC"]);
    const deterioration = allData.map((item) => item["Deterioration"]);
    const year = allData.map((item) => item.Year);
    setData({
      labels: year,
      datasets: [
        {
          label: "Total LCC",
          data: total_lcc,
          backgroundColor: "rgb(99,161,255)",
          borderColor: "rgb(99,161,255)",
          stack: "stack0",
        },
        {
          label: "Annualized LCC",
          data: data_annualized,
          backgroundColor: "rgb(99,255,120)",
          borderColor: "rgb(99,255,120)",
          stack: "stack2",
        },

        {
          label: "Cumulative LCC",
          data: cumulative,
          backgroundColor: "rgb(255, 99, 132)",
          borderColor: "rgb(255, 99, 132)",
          stack: "stack3",
        },
      ],
    });
  }, [allData]);
  return (
    <div style={{ position: "relative", height: "434px", width: "100%" }}>
      <Line options={options} data={data} />
    </div>
  );
}

export default App;
